import type { ElectronAPI } from "@observe-tech/utils";

type ElectronTemplateNavigationApi = Partial<
  Pick<ElectronAPI, "onTemplatesChanged" | "getScreen">
>;

function electronApi(): ElectronTemplateNavigationApi | undefined {
  return (window as unknown as { electronAPI?: ElectronTemplateNavigationApi })
    .electronAPI;
}

const stripLeading = (path: string) =>
  path.replace(/^#/, "").replace(/^\/+/, "");

async function navigateToStoredScreenRoute(
  api: ElectronTemplateNavigationApi,
  navigate: (path: string) => void,
): Promise<void> {
  const screen = await api.getScreen?.();
  const route = stripLeading(screen?.screenType ?? "");
  if (!route || route === stripLeading(window.location.pathname)) return;
  navigate(`/${route}`);
}

/**
 * Move this screen to the page a loaded layout template stored for it.
 *
 * Lives in the shell because the shell is mounted on every page, including
 * the ones whose app never listens (Feeding Analytics, the shell's own pages).
 * Only a load moves a screen: the other templates-changed broadcasts (save,
 * delete, a grid edit clearing the selection) leave every screen where it is.
 */
export function followLayoutTemplateLoads(
  navigate: (path: string) => void,
): () => void {
  const api = electronApi();
  if (!api?.onTemplatesChanged || !api.getScreen) return () => {};
  return api.onTemplatesChanged((_event, data) => {
    if (!data?.loaded) return;
    navigateToStoredScreenRoute(api, navigate).catch(() => {});
  });
}
